import React, { useState } from "react";
import ModalWrapperSmall from "../../../ui/ModalWrapper/ModalWrapperSmall";
import assest from "../../../json/assest";
// import styles from "../../../styles/components/approvemodal.module.scss";
import styles from "../../../styles/components/proceedModal.module.scss";
import { useMutation } from "react-query";
import { createNote } from "../../../api/functions/note.api";
import { Box } from "@mui/system";
import { Button } from "@mui/material";

const VideoWebsiteModal = ({
  open,
  onClose,
  handleUpdate,
  data,
  buttonText,
  modalHeaderText,
}) => {
  const [note, setNote] = useState("");
  //   console.warn("note", note);

  const { mutate } = useMutation(createNote, {
    onSuccess: (data) => {
      // console.warn("data", data);
    },
    onError: (error) => {
      // console.warn("error", error);
    },
  });
  // console.warn("data", data);

  const handleConfirmWebsite = () => {
    if (note) {
      mutate({
        note,
        note_key: "admin_website_only_reason",
        video_id: data.id,
      });
    }
    setNote("");
    onClose();
    handleUpdate(5);
  };
  return (
    <>
      <ModalWrapperSmall
        open={open}
        onClose={onClose}
        handleClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className={styles.websiteBtn}
      >
        <Box className={styles.proceedModalWrapper}>
          <h4>
            {modalHeaderText}
            <sup>*</sup>
          </h4>
          <Box className={styles.proceedModaltextarea}>
            <textarea maxLength={70} onChange={(e) => setNote(e.target.value)}>
              {note}
            </textarea>
            <Button className={styles.proceedModalCross}>
              <img src={assest.crossIconGray} width={12} height={12} alt="" />
            </Button>
            <p>{70 - note.length} charachters left.</p>
          </Box>

          <Box className={styles.messageModalFooter}>
            <Button className={styles.active} onClick={handleConfirmWebsite}>
              {buttonText}
            </Button>
            <Button onClick={onClose}>Cancel</Button>
          </Box>
        </Box>
      </ModalWrapperSmall>
    </>
  );
};

export default VideoWebsiteModal;
